import { NodeId } from 'web';
import { FlowGraph } from '../FlowGraph';

export class DilationErosionView {
  constructor(
    private graph: FlowGraph,
    private nodeId: NodeId,
  ) {}

  setSize(value: number, ongoing: boolean) {
    this.graph.wasmEdit((wasm) => {
      return wasm.setDilationErosionSize(this.nodeId, Math.round(value));
    }, ongoing);
    this.graph.updateNodeOutputs(this.nodeId, ongoing);
  }
}
